import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["setIsChatOpen", "setIsMenuOpen", "isMenuOpen", "messengers"];
import React from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { IconChevronLeft, IconCloseRoundStroked } from '@carnica/graphics';
import { selectChatCofig, selectIsMenuOpen, setChatOpen, setMenuOpen } from "../../../../entities/settings/model";
import { Button } from "../../../../shared/ui";
import { cnBem } from "../../../../shared/lib";
import styles from "./styles.pcss";
var cnBackButton = cnBem('btn-back-menu', styles);
var BackMenuRender = function BackMenuRender(_ref) {
  var setIsChatOpen = _ref.setIsChatOpen,
    setIsMenuOpen = _ref.setIsMenuOpen,
    isMenuOpen = _ref.isMenuOpen,
    _ref$messengers = _ref.messengers,
    messengers = _ref$messengers === void 0 ? [] : _ref$messengers,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isMobile = useIsMobileDimension();
  var onClick = function onClick() {
    setIsChatOpen(false);
    setIsMenuOpen(isMenuOpen ? false : messengers.length > 1);
  };
  return /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
    className: cnBackButton(null),
    iconLeft: isMobile || (messengers === null || messengers === void 0 ? void 0 : messengers.length) < 2 ? IconCloseRoundStroked : IconChevronLeft,
    onClick: onClick,
    onlyIcon: true,
    size: "m",
    view: "tertiary-invert",
    "data-t-id": "ui-BackMenu"
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isMenuOpen: selectIsMenuOpen(state),
    messengers: selectChatCofig(state).messengers
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setIsChatOpen: function setIsChatOpen(flag) {
      return dispatch(setChatOpen(flag));
    },
    setIsMenuOpen: function setIsMenuOpen(flag) {
      return dispatch(setMenuOpen(flag));
    }
  };
};
export var BackMenu = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(BackMenuRender);